<app-layout>
    <admin-reports-tab :referrer="filters.referrer" section="referrals"></admin-reports-tab>
    <h1 class="mt-10 mb-8 font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('admin.users.edit', filters.referrer)" v-if="filters.referrer">Go Back - </inertia-link> Referral Transactions
    </h1>
    <div class="bg-white rounded shadow overflow-x-auto">
        <table class="w-full whitespace-no-wrap">
            <tr class="text-left font-bold">
                <th class="px-3 pt-6 pb-4">Transaction ID</th>
                <th class="px-3 pt-6 pb-4">Status</th>
                <th class="px-3 pt-6 pb-4">Amount</th>
                <th class="px-3 pt-6 pb-4">User</th>
                <th class="px-3 pt-6 pb-4">Date</th>
            </tr>
            <tr v-for="transaction in transactions.data" :key="transaction.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t">
                    <span class="px-3 py-2 flex items-center">
                        {{ transaction.transaction_id }}
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-3 py-2 flex items-center">
                        <badge class="mr-2" :type="transaction.is_credited ? 'green' : 'orange'">
                            {{ transaction.is_credited ? 'Credited' : 'Pending' }}
                        </badge>
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-3 py-2 flex items-center">
                        {{ transaction.amount }} {{ transaction.currency.symbol }}
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-3 py-2 flex items-center">
                        {{ transaction.user.email }}<br> ID: {{ transaction.user.id }}
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-3 py-2 flex items-center">
                        {{ transaction.created_at }}
                    </span>
                </td>
            </tr>
            <tr v-if="transactions.data.length === 0">
                <td class="border-t px-3 py-2" colspan="100">No transactions found.</td>
            </tr>
        </table>
    </div>
    <pagination :links="transactions.links" />
</app-layout>
